export const SWEDISH_PARTIES = [
  {
    name: 'Socialdemokraterna',
    abbreviation: 'S',
    color: '#E30613',
  },
  {
    name: 'Moderaterna',
    abbreviation: 'M',
    color: '#006A52',
  },
  {
    name: 'Sverigedemokraterna',
    abbreviation: 'SD',
    color: '#006598',
  },
  {
    name: 'Centerpartiet',
    abbreviation: 'C',
    color: '#006A52',
  },
  {
    name: 'Liberalerna',
    abbreviation: 'L',
    color: '#FFCC00',
  },
  {
    name: 'Kristdemokraterna',
    abbreviation: 'KD',
    color: '#4B8E0B',
  },
  {
    name: 'Vänsterpartiet',
    abbreviation: 'V',
    color: '#D50032',
  },
  {
    name: 'Miljöpartiet',
    abbreviation: 'MP',
    color: '#6EBB46',
  },
  // Ungdomsförbund
  {
    name: 'Socialdemokratiska ungdomsförbundet',
    abbreviation: 'Socialdemokratiska ungdomsförbundet',
    color: '#E30613',
  },
  {
    name: 'Moderata ungdomsförbundet',
    abbreviation: 'Moderata ungdomsförbundet',
    color: '#006A52',
  },
  {
    name: 'Sverigedemokratisk ungdom',
    abbreviation: 'Sverigedemokratisk ungdom',
    color: '#006598',
  },
  {
    name: 'Centerpartiets ungdomsförbund',
    abbreviation: 'Centerpartiets ungdomsförbund',
    color: '#006A52',
  },
  {
    name: 'Liberala ungdomsförbundet',
    abbreviation: 'Liberala ungdomsförbundet',
    color: '#FFCC00',
  },
  {
    name: 'Kristdemokratiska ungdomsförbundet',
    abbreviation: 'Kristdemokratiska ungdomsförbundet',
    color: '#4B8E0B',
  },
  {
    name: 'Vänsterpartiets ungdomsförbund',
    abbreviation: 'Vänsterpartiets ungdomsförbund',
    color: '#D50032',
  },
  {
    name: 'Gröna ungdomar',
    abbreviation: 'Gröna ungdomar',
    color: '#6EBB46',
  },
];



